import { Stack } from '@mui/material'
import LabeledProgressIndicator from '../labeled-progress-indicator/LabeledProgressIndicator'
import { useFileUploadContext } from '../upload-files/FileUploadProvider'

export default function ProjectIndicators() {
  const { numberToUpload } = useFileUploadContext()

  return (
    <Stack direction="row" spacing={2} id="project-indicators-container">
      {numberToUpload > 0 && (
        <LabeledProgressIndicator>
          {`${numberToUpload} file${
            numberToUpload > 1 ? 's' : ''
          } uploading...`}
        </LabeledProgressIndicator>
      )}
    </Stack>
  )
}
